import React from 'react'
import PropTypes from 'prop-types'
import Item from '../../item'

import Styles from './index.scss'

const TabTaskList = (props) => {
  let runningProject = {
    order: [],
    detail: [],
    allTask: [],
  }
  if (Object.keys(props.allData.rows).length !== 0) {
    runningProject = {
      order: props.allData.rows.ordersData,
      detail: props.allData.rows.tasksStatus,
      allTask: props.taskData.rows,
    }
  }
  return (
    <section className={`section-tab ${Styles['section-tasklist']}`}>
      <div className={`${Styles['header-task']}`}>
        <div className={`${Styles['task-count-container']} ${Styles['total-task-count']}`}>
          <span className={`${Styles['task-count-label']}`}>Total Task</span>
          <span className={`${Styles['task-count-value']}`}>{props.taskStatus.allTask}</span>
        </div>
        <div className={`${Styles['task-count-container']}`}>
          <div className={`${Styles['task-detail-count-container']}`}>
            <span className={`${Styles.label}`}>Task Not Started</span>
            <span className={`${Styles.value}`}>{props.taskStatus.taskNotStarted}</span>
          </div>
          <div className={`${Styles['task-detail-count-container']}`}>
            <span className={`${Styles.label}`}>Task in Progress</span>
            <span className={`${Styles.value}`}>{props.taskStatus.taskInProgress}</span>
          </div>
          <div className={`${Styles['task-detail-count-container']}`}>
            <span className={`${Styles.label}`}>Task Completed</span>
            <span className={`${Styles.value}`}>{props.taskStatus.taskCompleted}</span>
          </div>
        </div>
      </div>
      <div className={`${Styles['header-task']}`}>
        <h3 className={`${Styles['tasklist-title']}`}>Task List</h3>
        {runningProject.allTask.length > 0 ?
          <table className="table table-hover table-light">
            <thead>
              <tr className="uppercase">
                <th> No </th>
                <th> Task Name </th>
                <th> Creator Workspace </th>
                <th> Product </th>
                <th> Task Status </th>
                <th> Task Deadline </th>
              </tr>
            </thead>
            <tbody>
              {
                runningProject.allTask.length === 0
                ? <tr>{}</tr>
                : runningProject.allTask.map((row, key) => (
                  <Item
                    indexKey={key}
                    key={row.id}
                    row={row}
                    taskStatusList={props.taskStatusList}
                    product={runningProject.order[0].productType.name}
                  />
                ))
              }
            </tbody>
          </table>
        :
          <div className={`${Styles['no-task']}`}>
            There is no task yet
          </div>
        }
      </div>
    </section>
  )
}

TabTaskList.propTypes = {
  taskStatus: PropTypes.shape({
    allTask: PropTypes.number.isRequired,
    taskNotStarted: PropTypes.number.isRequired,
    taskInProgress: PropTypes.number.isRequired,
    taskCompleted: PropTypes.number.isRequired,
  }).isRequired,
  allData: PropTypes.shape({
    rows: PropTypes.shape({}),
  }).isRequired,
  taskData: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  taskStatusList: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default TabTaskList
